import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { DownloadableBlob } from '@ps/utils';
import {
  BUYER_ENTRY_LINKS_TEMPLATE_FILE_NAME,
  BUYER_ENTRY_LINKS_TEMPLATE_PATH,
  UNIQUE_LINK_PSID_TEMPLATE_FILE_NAME,
  UNIQUE_LINK_PSID_TEMPLATE_PATH,
} from '@ps/survey-utils';

@Injectable({ providedIn: 'root' })
export class UniqueBuyerEntryLinksService {
  private readonly _document = inject(DOCUMENT);
  private readonly _http = inject(HttpClient);

  public downloadTemplateFile(): Observable<void> {
    return this._downloadTemplate(
      BUYER_ENTRY_LINKS_TEMPLATE_PATH,
      BUYER_ENTRY_LINKS_TEMPLATE_FILE_NAME,
    );
  }

  public downloadUniqueLinkPsidTemplateFile(): Observable<void> {
    return this._downloadTemplate(
      UNIQUE_LINK_PSID_TEMPLATE_PATH,
      UNIQUE_LINK_PSID_TEMPLATE_FILE_NAME,
    );
  }

  private _downloadTemplate(path: string, fileName: string): Observable<void> {
    return this._http.get(path, { responseType: 'blob' }).pipe(
      map((blob) => {
        new DownloadableBlob(blob, fileName, this._document).download();
      }),
    );
  }
}
